// 订单状态
export const orderStatusMap = {
  'WP': '等待付款',
  'PF': '已出票',
  'HP': '支付未出票',
  'XX': '已取消',
  'WF': '等待确认乘客'
}

// 乘客类型
export const travalerTypeMap = {
  'ADULT': '成人',
  'CHILD': '儿童',
  'INFANT': '婴儿'
}

// 证件类型（后续弃用）
export const [ idTypeMap, certificateTypeMap ] = [{
  'NI': '身份证',
  'ID16': '户口簿',
  'PP': '有效护照',
  'JG': '军官证',
  'NID': '外国人永久居留身份证',
  'HM': '港澳台居民居住证',
  'ID': '其他'
}, {
  'NI': '身份证',
  'ID16': '户口簿',
  'PP': '有效护照',
  'JG': '军官证',
  'NID': '外国人永久居留身份证',
  'HM': '港澳台居民居住证',
  'ID': '其他'
}]

// 全量 - 证件类型(用于展示和兼容旧数据)
export const idTypeV2Map = {
  'NI': '身份证',
  'PP': '护照',
  'JG': '军官',
  'FG': '外国人永久居留证',
  'WG': '外国人永久居留证',
  'HM': '港澳台居民居住证',
  'PP1': '外籍旅客护照',
  'NID': '外国人永久居留证',
  'ID1': '港澳通行证',
  'ID2': '大陆居民往来台湾通行证',
  'ID3': '文职干部证',
  'ID4': '义务兵证',
  'ID5': '士官证',
  'ID6': '文职人员证',
  'ID7': '职工证',
  'ID8': '武警警官证',
  'ID9': '武警士兵证',
  'ID10': '海员证',
  'ID11': '港澳居民来往内地通行证',
  'ID12': '台湾居民来往大陆通行证',
  'ID13': '外交部签发的驻华外交人员证',
  'ID14': '外国人永久居留证',
  'ID15': '出生医学证明',
  'ID16': '户口簿',
  'ID17': '学生证',
  'ID18': '户口所在地公安机关出具的身份证明',
  'ID19': '民航局规定的其他有效乘机身份证件',
  'ID20': '外国人出入境证',
  'ID21': '电子护照',
  'ID22': '身份证',
  'ID23': '护照',
  'ID24': '军官证',
  'ID25': '港澳台居民居住证',
  'ID26': '特殊身份证',
  'ID27': '公务护照',
  'ID28': '警官证',
  'ID29': '出生证明',
  'ID': '其他',
  'UU': '无法识别证件'
}

// 下单证件类型
export const orderCertificateMap = {
  'NI': '身份证',
  'PP': '有效护照',
  'HM': '港澳台居民居住证',
  // 'ID1': '港澳通行证', // 2023-05-30 删除
  'ID3': '文职干部证', // 2023-05-26 新增
  'ID4': '义务兵证', // 2023-05-26 新增
  'ID5': '士官证',
  'ID6': '文职人员证', // 2023-05-26 新增
  'ID7': '军方职工证', // 2023-05-26 新增
  'ID9': '武警士兵证', // 2023-05-30 新增
  'ID10': '海员证',
  'ID11': '港澳居民来往内地通行证', // 2023-05-26 新增
  'ID12': '台湾居民来往大陆通行证', // 2023-05-26 新增
  'ID13': '驻华外交人员证',
  'ID14': '外国人永久居留证',
  'ID16': '十六周岁以下户口薄',
  // 'ID17': '学生证', / 2023-05-30 删除
  // 'ID18': '户口所在地公安机关出具的身份证明', // 2023-05-30 删除
  'ID20': '外国人出入境证',
  'ID21': '电子护照',
  'ID24': '军官证',
  'ID26': '特殊身份证',
  'ID28': '警官证',
  // 'ID29': '出生证明', // 2023-05-30 删除
  'ID': '其他'
}

// 非中籍旅客下单证件类型(弃用)
export const orderCertificateWithoutDomesticMap = {
  'PP': '有效护照',
  'ID10': '海员证',
  'ID14': '外国人永久居留证',
  'ID20': '外国人出入境证'
}

// 代理人 & 军警残下单证件类型
export const orderCertificateDomesticMap = {
  'NI': '身份证',
  'HM': '港澳台居民居住证'
}

// 添加常用乘机人证件类型
export const usualPassengerMap = {
  'NI': '身份证',
  'PP': '有效护照',
  'HM': '港澳台居民居住证',
  // 'ID1': '港澳通行证', // 2023-05-30 删除
  'ID5': '士官证',
  'ID10': '海员证',
  'ID13': '驻华外交人员证',
  'ID14': '外国人永久居留证',
  // 'ID16': '户口薄',
  // 'ID17': '学生证',
  // 'ID18': '户口所在地公安机关出具的身份证明',
  'ID20': '外国人出入境证',
  'ID21': '电子护照',
  'ID24': '军官证',
  'ID26': '特殊身份证',
  'ID28': '警官证',
  // 'ID29': '出生证明', // 2023-05-30 删除
  'ID': '其他'
  // 'NI': '身份证',
  // 'PP': '有效护照',
  // 'HM': '港澳台居民居住证',
  // 'HK': '香港永久居民身份证',
  // 'TB': '台胞证',
  // 'TW': '台湾身份证',
  // 'MA': '澳门身份证',
  // 'ID1': '港澳通行证',
  // 'FT': '赴台证',
  // 'ID21': '电子护照',
  // 'ID14': '外国人永久居留证',
  // 'ID24': '军官证',
  // 'ID5': '士官证',
  // 'HX': '回乡证',
  // 'JD': '军队离退休证',
  // 'ID28': '警官证',
  // 'ID10': '海员证',
  // 'HR': '户口簿/出生证明/学生证/公安机关出具的身份证明',
  // 'ID13': '驻华外交人员证',
  // 'ID20': '外国人出入境证',
  // 'ID26': '特殊身份证',
  // 'ID': '其他'
}

// 航班状态
export const segmentStatusMap = {
  'RR': '已订座并确认完成出票',
  'HK': '已订座',
  'HL': '未占座',
  'HN': '候补',
  'NO': '航空公司不允许销售',
  'UC': '不接受候补或订座',
  'UN': '航班取消',
  'XL': '取消候补',
  'SA': '信息航段，不占座',
  'XX': '取消确认或申请'
}

// 客票状态
export const ticketStatusMap = {
  'OPEN_FOR_USE': '正常',
  'VOID': '已作废',
  'REFUNDED': '已退票',
  'CHECKED_IN': '已值机',
  'LIFT_OR_BOARED': '已登机',
  'USED_OR_FLOWN': '已使用',
  'SUSPENDED': '暂停使用',
  'PRINT_OR_EXCH': '已换开',
  'EXCHANGE': '已换开',
  'FIM_OR_EXCHANGE': '已换开',
  'EXCHANGED': '换开',
  'NN': '--'
}

// 改升 - 客票状态
export const ticketStatus2Map = {
  'OPEN_FOR_USE': '可使用', // 客票未使用,有效
  'VOID': '已作废', // 已作废
  'REFUNDED': '已退票', // 已退票
  'CHECKED_IN': '已经办理值机', // 已经办理值机
  'LIFT_OR_BOARED': '客票已使用', // 客票已使用（可修改）
  'USED_OR_FLOWN': '客票已使用', // 客票已使用（不可修改）
  'SUSPENDED': '禁止使用', // 系统处理，客票禁止使用
  'PRINT_OR_EXCH': '已换开为纸票', // 电子客票已换开为纸票
  'EXCHANGE': '换开', // 换开ET/手工换开
  'FIM_OR_EXCHANGE': '使用中断舱单签转外航', // 使用中断舱单签转外航
  'EXCHANGED': '换开',
  'NN': '--'
}

// 支付状态
export const payStatusMap = {
  'PENDING': '待支付',
  'PAID': '支付成功',
  'FAIL': '失败',
  'REFUNDING': '退款处理中',
  'REFUNDED': '退款成功'
}

// 支付方式
export const payTypeMap = {
  'ECARD': '易生支付',
  'EASYPAY': '易生支付',
  'ALIP': '支付宝支付',
  'YEEPAY': '易宝支付',
  'WECHAT': '微信支付',
  'WECHATH5': '微信H5支付',
  'CCB_PAY': '建行支付',
  'VR_PAY': '虚拟支付',
  'HB': '花呗分期',
  'CPAY': '汇付天下',
  'YKT': '一卡通（海航通）',
  'COUPON': '卡券抵扣',
  'DOUYIN': '抖音支付',
  'CHINAPAY_CUP': '云闪付',
  'CHINAPAY_ALI': '支付宝',
  'CHINAPAY_WX': '微信',
  'GNETE_CUP': '云闪付',
  'GNETE_ALI': '支付宝',
  'GNETE_WX': '微信',
  'GNETE': '网付通',
  'CASH': '现金',
  'POS_OFFLINE': '易生线上POS',
  'POS_ONLINE': '易生线下POS'
}

// 退单状态
export const refundStatusMap = {
  'INVALID': '退款审核中',
  'RPENDING': '处理中',
  'REFUND': '退款成功',
  'NEW': '审核中',
  'FPASS': '一审通过',
  'SNOPASS': '二审未通过',
  'SPASS': '二审通过',
  'REJECT': '重新二审',
  'FAIL': '退款失败',
  'APLY': '退款审核中',
  // 兼容B2B枚举
  'OPEN FOR USE': '已出票',
  FIRSTAUDIT: '一审',
  SECONDAUDIT: '二审',
  RESECONDAUDIT: '重新二审',
  REFUNDED: '已退票',
  SAUDIT: '补退款审核',
  SREFUNDED: '补退款',
  PASS: '二审通过',
  PAID: '已退款',
  PEND: '退款处理中',
  PAIDING: '退款进行中',
  SAPPLYING: '补退申请中',
  SREJECT: '补退申请被拒绝',
  ONLINE: '在线支付',
  OFFLINE: '线下支付',
  INTRADAY: '当日作废',
  UNCONSTRAINT: '自愿退票',
  CONSTRAINT: '非自愿退票',
  REPAIRREFUND: '补退票'
}

// 国际税费
export const inTaxMap = {
  CN: '民航发展基金',
  YQ: '航空保险附加费',
  YR: '航空公司燃油附加费',
  GB: '航空旅客税',
  UB: '旅客服务费',
  RI: '国际航站楼使用费',
  UH: '旅客安保费',
  AU: '旅客移动费',
  WG: '安保费',
  WY: '国际旅客服务费',
  E7: '旅客预先处理系统费',
  G8: '国际始发到达费',
  TS: '旅客服务费',
  OI: '乘客安保服务费',
  TK: '国际观光旅客税',
  SW: '乘客服务设施费',
  BP: '国际旅客离境税及全球疾病防控基金',
  TW: '机场服务费',
  F1: '边境清理税',
  KK: '旅客服务费',
  IA: '旅客安保费',
  HK: '航空旅客香港离境税',
  G3: '香港机场建设费',
  I5: '机场旅客安保费',
  MN: '旅客服务费',
  O6: '清关费',
  LA: '旅客服务费',
  YE: '燃油及杂费',
  CE: '税款'
}
